import React, { useContext, useEffect, useMemo } from 'react';
import Tabs from '../../components/tabs/tabs';
import AwaitingPO from './awaiting-po';
import InProgress from './in-progress';
import type { History } from 'history';
import { TitleService } from '../../services';
import { Breadcrumbs } from '../../store';

const POManager: React.FC<{ history: History }> = ({ history }) => {
  useEffect(() => {
    TitleService.setTitles('Sites Administration');
    Breadcrumbs.set([
      {
        url: '/purchase-orders',
        title: 'Purchase Order Administration',
      },
    ]);
  }, []);

  return (
    <div>
      <Tabs
        panes={[
          {
            path: '',
            label: 'Orders Awaiting Creation',
            Component: AwaitingPO,
          },
          {
            path: 'in-progress',
            label: 'Orders in Progress',
            Component: InProgress,
          },
        ]}
        history={history}
      />
    </div>
  );
};

export default POManager;
